module.exports = __webpack_public_path__ + "static/media/magic-link-error-desktop.2ee08ae6.svg";